import React from 'react'
import '../css/Header.css'
import Logo from '../images/Logo.png'
import {useNavigate} from 'react-router-dom'
const Header = () => {
    const navigate = useNavigate()
  return (
    <div className='header'>
        <img src={Logo} />
        <div className='navigationButtons'>
            <button onClick={() => {
              navigate("/")
            }}>홈</button>
            <button onClick={() => {
              navigate('/info')
            }}>학교소개
            </button>
            <button onClick={() => {
              navigate('/admissions')
            }}>입학안내</button>
            <button onClick={() => {
              navigate('/images')
            }}>갤러리</button>
            <button onClick={() => {
              navigate('/announcements')
            }}>광고</button>
        </div>
    </div>
  )
}

export default Header